import { Controller, useFormContext } from 'react-hook-form'

import { BankAccountInput, CheckBox, FF2 } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

type BankAccountProps = {
  index1: number
  index2: number
  index3: number
}

export const BankAccount = (props: BankAccountProps) => {
  const { index1, index2, index3 } = props
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.institutionsInfo.${index2 as 0}.accountNumbers.${index3 as 0}.number`}
      control={control}
      render={({ field }) => (
        <FormRow>
          <Col>
            <FF2 field={field} input={(props) => <BankAccountInput {...props} />} label="Account number (s)" />
          </Col>
          <Controller
            name={`subjectsInfo.${index1 as 0}.institutionsInfo.${index2 as 0}.accountNumbers[${index3 as 0}].closed`}
            render={({ field }) => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FF2 field={field} input={(props) => <CheckBox {...props} checkBoxLabel="Closed" />} />
              </div>
            )}
          />
        </FormRow>
      )}
    />
  )
}
